import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

export const currentStudentAtom = atom(null);
export const studentsAtom = atom(null);
export const studentsGraphAtom = atom(null);
export const currentCourseAtom = atomWithStorage('currentCourse', null);
export const isDarkModeAtom = atom(false);
export const headerMenuKeyAtom = atom('dashboard');
export const menuDrawerOpenAtom = atom(false);

export const userAtom = atomWithStorage('user', null);
export const userRecordAtom = atomWithStorage('userRecord', null);

export const showToastAtom = atom(false);
export const toastAtom = atom({ severity: 'info', duration: 0, message: '' });
export const modulesAtom = atom([]);
export const studentSupportTicketsAtom = atom(null);
